import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        data: Object,
        alertText: String,
        bannerQuantityText: String
    }

    openModal(event) {
        event.preventDefault()

        const modal = document.getElementById('loyalty-item-modal')
        if (!modal) return

        const modalController = this.application.getControllerForElementAndIdentifier(
            modal,
            'app-modal'
        )

        this.populateModal(modal)

        if (modalController) {
            modalController.open()
        }
    }

    populateModal(modal) {
        const data = this.dataValue

        const imageEl = modal.querySelector('[data-loyalty-modal-target="image"]')
        if (imageEl) {
            imageEl.style.setProperty('--checkout-modal-background-image', `url(${data.photoModal})`)
        }

        const titleEl = modal.querySelector('[data-loyalty-modal-target="title"]')
        if (titleEl) titleEl.textContent = data.title

        const descEl = modal.querySelector('[data-loyalty-modal-target="description"]')
        if (descEl) descEl.innerHTML = data.description

        const priceEl = modal.querySelector('[data-loyalty-modal-target="price"]')
        if (priceEl) priceEl.textContent = `${data.price}`

        const alertTextEl = modal.querySelector('[data-loyalty-modal-target="alertText"]')
        if (alertTextEl && this.hasAlertTextValue) {
            alertTextEl.innerHTML = this.alertTextValue
        }

        const bannerEl = modal.querySelector('[data-loyalty-modal-target="banner"]')
        const bannerQuantityEl = modal.querySelector('[data-loyalty-modal-target="bannerQuantity"]')

        if (this.hasBannerQuantityTextValue && bannerEl && bannerQuantityEl) {
            bannerEl.classList.remove('d-none')
            bannerQuantityEl.textContent = this.bannerQuantityTextValue
        } else {
            if (bannerEl) bannerEl.classList.add('d-none')
        }

        const quantityEl = modal.querySelector('[data-loyalty-modal-target="quantity"]')
        if (quantityEl) quantityEl.innerHTML = `<span class='fw-bold'>${data.quantityLeft}</span> / ${data.quantityTotal}`

        const itemIdInput = modal.querySelector('[data-loyalty-modal-target="itemId"]')
        if (itemIdInput) itemIdInput.value = data.id

        const purchaseBtn = modal.querySelector('[data-loyalty-modal-target="purchaseBtn"]')
        const alert = modal.querySelector('[data-loyalty-modal-target="alert"]')

        if (data.isPurchasable && data.isAvailable) {
            if (purchaseBtn) {
                purchaseBtn.classList.remove('app-modal__button--disabled')
                purchaseBtn.disabled = false;
            }
            if (alert) alert.classList.remove('app-modal__footer-alert--disabled')
        } else {
            if (purchaseBtn) {
                purchaseBtn.classList.add('app-modal__button--disabled')
                purchaseBtn.disabled = true;
            }
            if (alert) alert.classList.add('app-modal__footer-alert--disabled')
        }
    }
}
